import React from 'react'
import Detail from '../../../modules/ELearning/LearningPath/Detail'

const ElearningLearningPathDetailPage = () => {
  return <Detail />
}

export default ElearningLearningPathDetailPage
